import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

import { type ConfluenceCreatePageData } from './confluence-create-page-command';

/**
 * Properties for the Confluence page initialization command.
 */
export interface ConfluencePageInitCommandProperties extends CommandProperties {
	/**
	 * The contentId of the page being initialized.
	 */
	contentId: string;
	/**
	 * The action information to initialize the preview, equivalent format to Page create command
	 */
	data: ConfluenceCreatePageData;
}

/**
 * A command sent by a bridge API client to initialize a Confluence page preview with
 * the selected action's data once, after the content surface is ready.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId}
 * to initialize its state from the provided action payload.
 */
export const ConfluencePageInitCommand = createCommand<ConfluencePageInitCommandProperties, void>(
	'confluence-page-init-command',
);
